import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Home, Calendar, Settings, Menu, X } from 'lucide-react';
import { useState } from 'react';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 glass-nav border-b border-[#E5E0D8]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src="https://media.ulule.com/presales/3/8/9/8/7/1/178983/logo_v1--2-.5BO4CeI5zf.jpg" 
              alt="Plume et Pion"
              className="h-10 md:h-12 w-auto rounded-xl object-contain"
            />
            <div className="hidden sm:block">
              <h1 className="font-heading font-bold text-lg md:text-xl text-[#2D2A26]">Plume et Pion</h1>
              <p className="text-xs text-[#645E55]">Librairie ludique</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-2">
            <Link 
              to="/" 
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
              data-testid="nav-home"
            >
              Événements
            </Link>
            <Link 
              to="/admin" 
              className={`nav-link ${location.pathname.startsWith('/admin') ? 'active' : ''}`}
              data-testid="nav-admin"
            >
              Espace admin
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button 
            className="md:hidden p-2 rounded-xl hover:bg-[#FFF8E1]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-[#E5E0D8] animate-fade-in">
            <div className="flex flex-col gap-2">
              <Link 
                to="/" 
                className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Événements
              </Link>
              <Link 
                to="/admin" 
                className={`nav-link ${location.pathname.startsWith('/admin') ? 'active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Espace admin
              </Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
